var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls + '-head',style:({
			width: _vm.headerWidth
		})},[_c('table',{style:(_vm.styles),attrs:{"cellspacing":"0","cellpadding":"0","border":"0"}},[_c('colgroup',[_vm._l((_vm.endColumns),function(col,i){return _c('col',{key:i,attrs:{"width":col.width}})}),(_vm.showVerticalScrollBar)?_c('col',{attrs:{"width":_vm.$parent.scrollBarWidth}}):_vm._e()],2),_c('thead',_vm._l((_vm.stackColumns),function(floor,i){return _c('tr',{key:i},_vm._l((floor),function(col,j){return _c('th',{key:j,class:[
	        				_vm.prefixCls + '-th',
	        				{
	        					'with-border': _vm.stackColumns.length > 1
	        				}
        				],style:({
	        				height: col._rowspan * 40 + 'px',
							'visibility': col.fixed == _vm.location ? 'visible' : 'hidden'
						}),attrs:{"align":col.align || 'center',"rowspan":col._rowspan,"colspan":col._colspan}},[_vm._v(" "+_vm._s(col.title)+" ")])}),0)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }